/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_M2Inputs */

const cs_price_unit_suffix_m2 = /** @type {(inputs: Price_Unit_Suffix_M2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²`)
};

const en_price_unit_suffix_m2 = /** @type {(inputs: Price_Unit_Suffix_M2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²`)
};

/**
* | output |
* | --- |
* | "/m²" |
*
* @param {Price_Unit_Suffix_M2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_m2 = /** @type {((inputs?: Price_Unit_Suffix_M2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_M2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_m2(inputs)
	return cs_price_unit_suffix_m2(inputs)
});